import { SET_ACTIVE_DROPDOWN } from 'store/types';

export const setActiveDropDown = (expandedId) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_DROPDOWN,
    payload: expandedId,
  });
};
